module.exports = __webpack_public_path__ + "static/media/close-black-icon.e6c3d728.svg";